(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
    (() => {
        const updateItem = (item, isOpen) => {
            item.classList.toggle('is-open', isOpen);
            item.querySelector('[data-faq-summary]').setAttribute('aria-expanded', String(isOpen));
        };

        const init = root => {
            const sections = root.matches && root.matches('[data-faq-section]')
                ? [root]
                : root.querySelectorAll('[data-faq-section]');

            sections.forEach(section => {
                if (section.dataset.faqReady) return;

                section.dataset.faqReady = 'true';

                section.addEventListener('click', event => {
                    const summary = event.target.closest('[data-faq-summary]');

                    if (!summary || !section.contains(summary)) return;

                    const currentItem = summary.closest('[data-faq-item]');
                    const shouldOpen = !currentItem.classList.contains('is-open');

                    section.querySelectorAll('[data-faq-item].is-open').forEach(item => updateItem(item, false));

                    if (shouldOpen) updateItem(currentItem, true);
                });
            });
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => init(document));
        } else {
            init(document);
        }

        document.addEventListener('shopify:section:load', event => init(event.target));
    })();

  } catch(e) { console.error(e); }
})();
})();
